import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { initMetaPixel, trackEvent } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackEvent('PageView');
  }, []);
  return <main className="min-h-screen bg-white selection:bg-stone-200 selection:text-stone-900" data-id="element-175">
      <HeroSection data-id="element-176" />
      <FeaturesSection data-id="element-177" />
      <BenefitsSection data-id="element-178" />
      <GuaranteeSection data-id="element-179" />
      <CTASection data-id="element-180" />
      <Footer data-id="element-181" />
    </main>;
}